"use strict";
exports.__esModule = true;
exports.Rating = void 0;
var tslib_1 = require("tslib");
var styles_1 = require("@material-ui/core/styles");
var Tooltip_1 = tslib_1.__importDefault(require("@material-ui/core/Tooltip"));
var Rating_1 = tslib_1.__importDefault(require("@material-ui/lab/Rating"));
var react_1 = tslib_1.__importDefault(require("react"));
var __1 = require("..");
var useStyles = __1.makeStyles(function (theme) {
    return __1.createStyles({
        ratingContainer: {
            alignItems: 'flex-end'
        },
        houseDescription: {
            margin: '0 auto',
            display: 'table',
            color: "" + theme.palette.common.black,
            textAlign: 'center'
        }
    });
});
function Rating(props) {
    var theme = styles_1.useTheme();
    var scaled = props.scaled, selectedIndex = props.selectedIndex, _a = props.inactiveColor, inactiveColor = _a === void 0 ? theme.palette.action.disabled : _a, _b = props.activeColor, activeColor = _b === void 0 ? theme.palette.primary.main : _b, component = props.component, emptyComponent = props.emptyComponent, onIconClick = props.onIconClick, labeled = props.labeled, labels = props.labels, iconSpacing = props.iconSpacing, iconTooltipLabels = props.iconTooltipLabels, _c = props.size, size = _c === void 0 ? 'medium' : _c, max = props.max, rest = tslib_1.__rest(props, ["scaled", "selectedIndex", "inactiveColor", "activeColor", "component", "emptyComponent", "onIconClick", "labeled", "labels", "iconSpacing", "iconTooltipLabels", "size", "max"]);
    var classes = useStyles();
    var icons = getIcons(max, component, size, emptyComponent, selectedIndex, scaled, labels, inactiveColor, activeColor, onIconClick, labeled, classes, iconSpacing) || [];
    var IconContainer = function (props) {
        var value = props.value;
        return react_1["default"].createElement("span", null, icons[value - 1]);
    };
    return (react_1["default"].createElement(Rating_1["default"], tslib_1.__assign({}, rest, { IconContainerComponent: IconContainer, className: classes.ratingContainer, max: max })));
}
exports.Rating = Rating;
var getIcons = function (max, component, size, emptyComponent, selectedIndex, scaled, labels, inactiveColor, activeColor, onIconClick, labeled, classes, iconSpacing) {
    return Array.from({ length: max }).map(function (_v, i) {
        var renderComponent = component;
        if (emptyComponent != null && (!selectedIndex || i >= selectedIndex))
            renderComponent = emptyComponent;
        var scaleInitial = size === 'large' ? 1.5 : size === 'small' ? 0.7 : 1;
        var scaleValue = scaled ? (i * 0.15 + 0.5) * scaleInitial : scaleInitial;
        return (react_1["default"].createElement(Tooltip_1["default"], { arrow: true, key: i, placement: "top", title: labels && labels[i] ? labels[i] : '' },
            react_1["default"].createElement("span", { style: {
                    display: 'block',
                    marginRight: iconSpacing || 1 + (scaled ? i * 5 : 10) + "px"
                } },
                react_1["default"].createElement("div", { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        transform: "scale(" + scaleValue + ")",
                        position: 'relative',
                        top: scaled ? 10 - i * 2.5 + "px" : 0
                    } }, react_1["default"].cloneElement(renderComponent, {
                    style: { cursor: 'pointer' },
                    color: typeof selectedIndex === 'undefined' || i > selectedIndex
                        ? inactiveColor
                        : activeColor,
                    fill: typeof selectedIndex === 'undefined' || i > selectedIndex
                        ? inactiveColor
                        : activeColor,
                    customColor: typeof selectedIndex === 'undefined' || i > selectedIndex
                        ? inactiveColor
                        : activeColor,
                    htmlColor: typeof selectedIndex === 'undefined' || i > selectedIndex
                        ? inactiveColor
                        : activeColor,
                    onClick: function () { return onIconClick && onIconClick(i); }
                })),
                labeled ? (react_1["default"].createElement(__1.SmallText, { className: classes.houseDescription }, labels && labels[i] ? labels[i] : '')) : null)));
    });
};
//# sourceMappingURL=Rating.js.map